import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { BalanceStore } from '../../account/balance/balance.store';
import { RenewalBonus } from './models/renewal-bonus.model';
import { config } from '../../shared/config';
import { MemberQuery } from '../../account/member/member.query';

/**
 * This renewal bonus credit service will make a request to an endpoint responsible for
 * retrieving the renewal bonus purse balance, as well as the all other purse balances.
 * It must be passed with the externalRef of the user and will return the purse balances of all members
 * linked to the supplied externalRef.
 */
@Injectable({ providedIn: 'root' })
export class RenewalBonusService {
  constructor(private balanceStore: BalanceStore, private api: ApiService, private memberQuery: MemberQuery) {}

  /**
   * @returns This method will get the current users external ref, which will be passed to the required endpoint.
   * This will also update the balance store for purse number 5 (renewal bonus credit) with the balance
   * received from the response.
   */
  getRenewalBonusData() {
    let currentMember = this.memberQuery.getUserContext();
    let externalRef = currentMember.externalRef;
    return this.api.getAnySingle<RenewalBonus>('bonuscredit/accountpursebalance?externalRef=' + externalRef).pipe(
      tap((entities) => {
        let renewalBonus =
          entities.Members.filter((member) => member.MemberID === currentMember.memberId)[0].RenewalBalanceInPence / 100;
        this.balanceStore.upsert(currentMember.memberId + '-5', {
          purseId: config.purseConfig.renewalGift,
          memberId: currentMember.memberId || '',
          balance: renewalBonus,
        });
      })
    );
  }
}
